import { Stack, SxProps, TextField, Typography, useTheme } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import JSEditableInput from "./JSEditableInput";


interface DatePickerProps {
    value?: Date;
    placeholder?: string;
    onChange?: (date: Date) => void;
    sx?: SxProps;
}

export const JSDatePicker = ({ onChange: onChangeProp, ...props }: DatePickerProps) => {

    const theme = useTheme();

    return (
        <Stack sx={props.sx} direction="column" gap={0.5} alignItems="flex-start" justifyContent="space-between">


            <DesktopDatePicker
                format="EEEE MMMM dd, yyyy"
                slotProps={{
                    textField: {
                        sx: {
                            width: "100%",
                            height: "40px",
                            '& fieldset': {
                                borderColor: theme.palette.divider,
                            },
                        },
                        size: "small",
                    }
                }}

                formatDensity="spacious"
                value={props.value}
                onChange={(date) => onChangeProp?.(date as Date)}
            />

        </Stack>
    );
}